module.exports = __webpack_public_path__ + "img/tag4.c379b25e.png";